<script>
  import Footer from "./Footer.svelte";

  export let startScan;
  export let loadImage;

  getParam();
  function getParam() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pic = urlParams.get("pic");
    if (pic > 0) {
      loadImage(pic);
    }
  }
</script>

<div
  class="w-100 h-100 bg-custom-yellow absolute top-0 left-0 z-2 pa4 flex flex-column"
>
  <h1 class="f2">Bureaucratics</h1>
  <p class="f4 lh-copy">
    Une exposition de photographies augmentées pour les 40 ans de l'IDHEAP
  </p>
  <Footer {startScan} colorClass="bg-custom-yellow" />
</div>
